<template>
  <b-modal
    ref="modal"
    :id="modalId"
    :title="title"
    size="md"
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="form-group">
      <div class="radio-group">
        <b-form-radio
          v-for="option in options"
          :key="option.value"
          v-model="selectedValue"
          :name="radioName"
          :value="option.value"
          :disabled="disabledOptions.includes(option.value)"
        >
          <span :class="{ 'text-muted': disabledOptions.includes(option.value) }">
            {{ option.text }}
            <small v-if="disabledOptions.includes(option.value)" class="ml-1 text-danger">(Not allowed)</small>
          </span>
        </b-form-radio>
      </div>
      <div v-if="validationMessage" class="alert alert-warning mt-3 mb-0" role="alert">
        <i class="fas fa-exclamation-triangle mr-1"></i>{{ validationMessage }}
      </div>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="cancel">Cancel</b-button>
      <b-button variant="primary" @click="save">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
import { getDisabledStatusOptions, validateStatusTransition } from '../../../../../utils/paper-response-status'

export default {
    name: 'UpdateOptionModal',
    props: {
        title: { type: String, required: true },
        options: { type: Array, required: true },
        modalId: { type: String, default: 'updateOptionModal' },
        radioName: { type: String, default: 'updateOption' },
        selectedRowStatuses: { type: Array, default: () => [] },
    },
    data() {
        return {
            selectedValue: '',
            validationMessage: '',
        }
    },
    computed: {
        disabledOptions() {
            return getDisabledStatusOptions(this.selectedRowStatuses)
        },
    },
    methods: {
        forceRerender() {
            this.selectedValue = ''
            this.validationMessage = ''
            this.$refs.modal.show()
        },
        save() {
            this.validationMessage = ''
            if (!this.selectedValue) {
                this.validationMessage = 'Please select an option before saving.'
                return
            }
            const error = validateStatusTransition(this.selectedRowStatuses, this.selectedValue)
            if (error) {
                this.validationMessage = error
                return
            }
            this.$emit('save', this.selectedValue)
            this.$refs.modal.hide()
        },
        cancel() {
            this.validationMessage = ''
            this.$refs.modal.hide()
        },
    },
}
</script>

<style scoped>
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
